__turbopack_context__.v({
  "className": "caveat_e4f905ff-module__dXBQoq__className",
});
